import { createMuiStyles } from '../../utils/mui';

export const profilePageStyles = createMuiStyles({
  profileCard: {
    p: 2.5,
    borderRadius: '1rem',
    bgcolor: 'grey.50',
  },
});
